<template>
    <v-navigation-drawer app class="left-menu">

        <v-list :disabled="appStore.User.NeedsToChangePassword" nav class="left-menu__top-nav">

            <!-- Domov -->
            <v-list-item v-if="appStore.User.CanAccessPortal" title="Domov" :to="{ name: 'dashboard_dashboard' }"
                :prepend-icon="route.matched.some(x => x.name == 'dashboard_dashboard') ? 'custom:iconMenuDomovActive' : 'custom:iconMenuDomovInactive'">
            </v-list-item>

            <!-- Pogodbe -->
            <v-list-item v-if="appStore.User.CanAccessPortal" title="Pogodbe" :to="{ name: 'pogodbe_seznam' }"
                :prepend-icon="route.matched.some(x => x.name == 'pogodbe_seznam') ? 'custom:iconMenuPogodbeActive' : 'custom:iconMenuPogodbeInactive'">
            </v-list-item>

            <!-- Zaključek pogodbe -->
            <v-list-item v-if="appStore.User.PartnerId == 11" title="Zaključek pogodbe"
                :to="{ name: 'dokoncanje_pogodba' }"
                :prepend-icon="route.matched.some(x => x.name == 'dokoncanje_pogodba') ? 'custom:iconMenuPogodbeActive' : 'custom:iconMenuPogodbeInactive'">
            </v-list-item>

            <!-- Izračun limita -->
            <v-list-item v-if="appStore.User.CanAccessPortal" title="Izračun limita"
                :to="{ name: 'limitCalculationHome' }"
                :prepend-icon="route.matched.some(x => x.name == 'limitCalculationHome') ? 'custom:iconMenuIzracunLimitaActive' : 'custom:iconMenuIzracunLimitaInactive'">
            </v-list-item>

            <!-- Izračun obrokov -->
            <v-list-item v-if="appStore.User.CanAccessPortal && appStore.User.CanAccessCalc"
                title="Izračun obrokov" :to="{ name: 'informativeCalculationHome' }"
                :prepend-icon="route.matched.some(x => x.name == 'informativeCalculationHome') ? 'custom:iconMenuIzracunObrokaActive' : 'custom:iconMenuIzracunObrokaInactive'">
            </v-list-item>

            <!-- Mobile links -->
            <div class="d-lg-none">
                <hr class="hr mt-8 mb-8" />

                <!-- Uporabniški center / informacije -->
                <v-list-item rounded title="Informacije" :to="{ name: 'info_home' }"
                    :prepend-icon="route.matched.some(x => x.name == 'info_home') ? 'custom:iconAppBarInformacijeActive' : 'custom:iconAppBarInformacijeInactive'">
                </v-list-item>

                <!-- Uporabniški center / informacije -->
                <v-list-item rounded title="Izobraževanja" :to="{ name: 'training_home' }"
                    :prepend-icon="route.matched.some(x => x.name == 'training_home') ? 'custom:iconAppBarCertificateActive' : 'custom:iconAppBarCertificateInactive'">
                </v-list-item>

                <!-- Uporabniški center / informacije -->
                <v-list-item rounded title="Kontakt" :to="{ name: 'contact_home' }"
                    :prepend-icon="route.matched.some(x => x.name == 'contact_home') ? 'custom:iconAppBarContactActive' : 'custom:iconAppBarContactInactive'">
                </v-list-item>

            </div>

        </v-list>

        <div class="callout-help">
            <img src="@assets/images/contact/icon-callout-phone.svg" alt="Telefon" />
            <div>
                <div class="">Pomoč pri uporabi</div>
                <div class="font-weight-600 indigo-100">{{ currentPhone }}</div>
                <div class="font-size-75 mt-1 ">Številka ni namenjena strankam.</div>
            </div>
        </div>

    </v-navigation-drawer>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { useAppStore } from "@/app/store/app/store";
    import { useRoute } from "vue-router";

    const appStore = useAppStore();
    const route = useRoute();

    const currentPhone = computed(() => {
        const now = new Date()
        const day = now.getDay() // 0 = nedelja, 1 = ponedeljek, ..., 6 = sobota
        const hour = now.getHours()

        const isMondayToThursday = day >= 1 && day <= 4
        const isFriday = day === 5

        const isWithinWorkingHours =
            (isMondayToThursday && hour >= 8 && hour < 16) ||
            (isFriday && hour >= 8 && hour < 15)

        return isWithinWorkingHours ? '01 320 05 51' : '051 369 519'
    })
</script>
